var moduleMap = {
	"./useHubRoutes": function() {
		return Promise.all(/* __federation_expose_useHubRoutes */[__webpack_require__.e(5534), __webpack_require__.e(7096)]).then(function() { return function() { return (__webpack_require__(3566)); }; });
	},
	"./useTelevetRoutes": function() {
		return Promise.all(/* __federation_expose_useTelevetRoutes */[__webpack_require__.e(5534), __webpack_require__.e(7096)]).then(function() { return function() { return (__webpack_require__(3566)); }; });
	},
	"./useFormattedTelevetRoutes": function() {
		return Promise.all(/* __federation_expose_useFormattedTelevetRoutes */[__webpack_require__.e(6396), __webpack_require__.e(6201), __webpack_require__.e(8351), __webpack_require__.e(8861), __webpack_require__.e(6416), __webpack_require__.e(3196), __webpack_require__.e(8668), __webpack_require__.e(5383), __webpack_require__.e(6984), __webpack_require__.e(4036), __webpack_require__.e(2586), __webpack_require__.e(92), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(9252), __webpack_require__.e(5534), __webpack_require__.e(9138)]).then(function() { return function() { return (__webpack_require__(3594)); }; });
	},
	"./useMostViewedTelevetRoutes": function() {
		return Promise.all(/* __federation_expose_useMostViewedTelevetRoutes */[__webpack_require__.e(6396), __webpack_require__.e(6201), __webpack_require__.e(8351), __webpack_require__.e(8861), __webpack_require__.e(6416), __webpack_require__.e(3196), __webpack_require__.e(8668), __webpack_require__.e(5383), __webpack_require__.e(6984), __webpack_require__.e(4036), __webpack_require__.e(2586), __webpack_require__.e(92), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(9252), __webpack_require__.e(5534), __webpack_require__.e(5923)]).then(function() { return function() { return (__webpack_require__(5187)); }; });
	},
	"./TelevetProductSection": function() {
		return Promise.all(/* __federation_expose_TelevetProductSection */[__webpack_require__.e(6396), __webpack_require__.e(6201), __webpack_require__.e(8351), __webpack_require__.e(8861), __webpack_require__.e(6416), __webpack_require__.e(3196), __webpack_require__.e(8668), __webpack_require__.e(5383), __webpack_require__.e(6984), __webpack_require__.e(4114), __webpack_require__.e(4036), __webpack_require__.e(2586), __webpack_require__.e(92), __webpack_require__.e(8486), __webpack_require__.e(9172), __webpack_require__.e(3732), __webpack_require__.e(8122), __webpack_require__.e(1995), __webpack_require__.e(9252), __webpack_require__.e(5534), __webpack_require__.e(865), __webpack_require__.e(5935)]).then(function() { return function() { return (__webpack_require__(8765)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});